import type { ReactNode } from 'react';

interface AlertProps {
  tone?: 'error' | 'success' | 'info' | 'warning';
  children: ReactNode;
}

const TONE_CLASS: Record<NonNullable<AlertProps['tone']>, string> = {
  error:
    'bg-red-50 border-red-200 text-danger dark:bg-danger/10 dark:border-danger/30',
  success:
    'bg-green-50 border-green-200 text-success dark:bg-success/10 dark:border-success/30',
  info: 'bg-blue-50 border-blue-200 text-info dark:bg-info/10 dark:border-info/30',
  warning:
    'bg-amber-50 border-amber-200 text-amber-700 dark:bg-amber-400/10 dark:border-amber-400/30 dark:text-amber-300',
};

/**
 * 공용 인라인 알림. 모든 도메인에서 사용 가능.
 * (전역 토스트/모달은 @platform/ui 의 showAlert/showConfirm 참조)
 */
export function Alert({ tone = 'info', children }: AlertProps) {
  return (
    <div
      role={tone === 'error' ? 'alert' : 'status'}
      // 한글은 기본이 글자 단위 줄바꿈이라 "확인|해 주세요"처럼 단어가 잘린다 → 어절 단위(break-keep).
      // 띄어쓰기 없는 긴 값(이메일 등)은 넘치지 않게 break-words, 문구 속 '\n' 은 줄바꿈으로(pre-line).
      className={`whitespace-pre-line break-keep break-words rounded border px-3 py-2 text-sm ${TONE_CLASS[tone]}`}
    >
      {children}
    </div>
  );
}
